module.exports = __webpack_public_path__ + "img/anquan.e209084f.png";